var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vxe-grid',{attrs:{"size":"mini","border":"","resizable":"","auto-resize":"","highlight-hover-row":"","data":_vm.tableData,"columns":_vm.tableColumns,"loading":_vm.loading,"height":_vm.height},scopedSlots:_vm._u([{key:"opt",fn:function(ref){
var row = ref.row;
return [_c('el-tooltip',{attrs:{"effect":"dark","content":_vm.$l('btn_remove') || '移除',"placement":"top"}},[_c('i',{staticClass:"el-icon-delete tool-btn",on:{"click":function($event){return _vm.remove(row)}}})])]}},{key:"displayName",fn:function(ref){
var row = ref.row;
return [_vm._v(" "+_vm._s(row.displayUserName)+" "),(row.v_userStatus)?_c('el-tag',{attrs:{"size":"mini","type":row.userStatus === 'N'
            ? 'warning'
            : row.userStatus === 'S'
            ? 'danger'
            : row.userStatus === 'Y'
            ? 'success'
            : ''}},[_vm._v(" "+_vm._s(row.v_userStatus)+" ")]):_vm._e()]}},{key:"empty",fn:function(){return [_vm._v(" "+_vm._s(_vm.$l('table_empty_userTable') || '请选择未授权用户')+" ")]},proxy:true}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }